export enum AudioCodecs {
    G711 = 'audio/wav; codecs="1"',
    G729 = 'audio/G729',
    G722 = 'audio/G722'
}

export enum VideoCodecs {
    H264 = 'video/mp4; codecs="avc1.4d002a"',
    VP8 = 'video/webm; codecs="vp8, vorbis"',
    VP9 = 'video/webm; codecs="vp9"'
}
